import { getI18n } from 'react-i18next';

export const VALIDATION_BIDDING_INVALID_DEFAULT_QUANTITY = 'validation.biddingUserConfiguration.invalidDefaultQuantity';
export const VALIDATION_BIDDING_INVALID_PRICE_STEP = 'validation.biddingUserConfiguration.invalidPriceStep';
export const VALIDATION_BIDDING_INVALID_QUANTITY_STEP = 'validation.biddingUserConfiguration.invalidQuantityStep';

export const createUserConfigurationErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_BIDDING_INVALID_DEFAULT_QUANTITY:
            result = i18n.t('user-configuration.bidding.error.invalid-default-quantity');
            break;
        case VALIDATION_BIDDING_INVALID_PRICE_STEP:
            result = i18n.t('user-configuration.bidding.error.invalid-price-step');
            break;
        case VALIDATION_BIDDING_INVALID_QUANTITY_STEP:
            result = i18n.t('user-configuration.bidding.error.invalid-quantity-step');
            break;
        default:
            result = undefined;
    }
    return result;
};
